/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function CustomTextField(props) {
  const classes = useStyles();
  return <TextField inputProps={{ 'data-testid': 'mui-textfield' }} className={classes.input} fullWidth margin="none" variant="outlined" color="primary" {...props} />;
}

CustomTextField.propTypes = TextField.propTypes;

export default CustomTextField;
